module.exports = __webpack_public_path__ + "img/wine-glass.75c20d15.svg";